class CollectionSelector {

	constructor() {

		this.onScroll = this.onScroll.bind(this);
		this.toggleShow = this.toggleShow.bind(this);
		this.toggleCat = this.toggleCat.bind(this);

		this.$selector = $('.CollectionSelector');
		if (this.$selector.length) {
			this.init();
		}

	}

	init() {

		this.$toggler = this.$selector.find('.Link');
		this.$inner = this.$selector.find('.CollectionSelector__Inner');
		this.$cats = this.$selector.find('.CollectionSelector__Cats a');
		this.$catsLists = this.$selector.find('.CollectionSelector__Cat');

		this.setOffset();
		$(window).on('scroll', this.onScroll);
		this.$toggler.on('click', this.toggleShow);
		this.$cats.on('click', this.toggleCat);

	}

	setOffset() {

		this.$selector.removeClass('fixed');
		this.$selector.height(this.$inner.outerHeight());
		this.selectorOffset = this.$selector.offset().top - $('header').outerHeight();
		this.onScroll();

	}

	onScroll() {

		if ($(window).scrollTop() >= this.selectorOffset) {
			this.$selector.addClass('fixed');
		} else {
			this.$selector.removeClass('fixed');
		}

	}

	toggleShow() {

		this.$selector.toggleClass('show-list');

	}

	toggleCat(e) {

		e.preventDefault();
		const currentLi = $(e.target).parent();
		const newListId = $(e.target).data('select');
		const newList = this.$catsLists.filter((index, item) => {
			return $(item).attr('id') == newListId;
		});

		this.$catsLists.fadeOut();
		setTimeout(() => {
			this.$cats.closest('ul').find('li').removeClass('active');
			currentLi.addClass('active');
			console.log(newList);
			this.$catsLists.removeClass('CollectionSelector__Cat--show').removeAttr('style');
			newList.fadeIn(500, () => {
				newList.removeAttr('style');
				newList.addClass('CollectionSelector__Cat--show');
			})
		}, 500);

	}

}

export default new CollectionSelector();



// WEBPACK FOOTER //
// ./js/components/collectionSelector.js